import { generatePath, Link, useParams, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectLabels } from "../../store/labelsSlice";
import { useEffect, useState } from "react";
import { api } from "../../store/api";
import Project from "../../models/project";
import Partner from "../../models/partner";
import GradeTypes from "../../models/gradeTypes";
import { PartnerDetailsRoute } from "../partners/partnerDetailsScreen";
import GradeUnit from "../../models/gradeUnit";
import { Panel, PanelBody } from "../../components/panel/panel";
import { format } from "../../helpers/format";

interface ProjectEditGradeScreenParams {
  id?: number;
  grade?: GradeTypes;
}


export default function ProjectEditGradeScreen() {

  const params = useParams<keyof ProjectEditGradeScreenParams>();
  const [searchParams, setSearchParams] = useSearchParams();

  const labels = useAppSelector(selectLabels);
  const label = labels.project;

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<String>();

  const [project, setProject] = useState<Project>();
  const [grade, setGrade] = useState<GradeTypes>();
  const [gradeUnits, setGradeUnits] = useState<GradeUnit[]>();
  const [deleted, setDeleted] = useState<GradeUnit>();
  //const [partner, setPartner] = useState<Partner>();


  useEffect(() => {
    if (params.id!) {
      // load specified partner
      setIsLoading(true);
      api.projects.get(parseInt(params.id!))
        .then(result => {
          setError(undefined);
          setProject(result);
          setIsLoading(false);
          const grade = GradeTypes[params.grade as keyof typeof GradeTypes];
          setGrade(grade);
        });
    }
  }, [params.grade, params.id]);

  useEffect(() => {
    if (project && grade) {
      setIsLoading(true);
      api.project(project.id!).grade(grade).units()
        .then((gradeUnits) => {
          setError(undefined);
          setGradeUnits(gradeUnits);
          setIsLoading(false);
        })
        .catch((reason) => {
          setError("Unable to load Grade " + grade + ": " + reason);
          setIsLoading(false);
        });

    }

  }, [grade, project, deleted]);

  const onDeleteUnit = (gradeUnit: GradeUnit) => {
    setIsLoading(true);
    setError(undefined);
    api.project(project!.id!).grade(gradeUnit.grade).unit(gradeUnit.unit).delete(gradeUnit.id!)
      .then((response) => {
        setError(undefined);
        setIsLoading(false);
        setDeleted(gradeUnit);
      })
      .catch((reason) => {
        setError("Unable to delete Unit " + gradeUnit.unit + ": " + reason);
        setIsLoading(false);
      });

  };

  return (<div>
    <ol className="breadcrumb float-xl-end">
      {project?.partner && <li className="breadcrumb-item"><Link to={generatePath(PartnerDetailsRoute, { id: `${project.partner.id}` })}>{project.partner.name}</Link></li>}
      {project && <li className="breadcrumb-item"><Link to="../../.." relative="path">{label.singular} {project?.name}</Link></li>}
      {project && grade && <li className="breadcrumb-item"><Link to="../.." relative="path">Grade {grade}</Link></li>}
      <li className="breadcrumb-item active">Edit</li>
    </ol>
    <h1 className="page-header">Grade {grade}</h1>
    {error && <div className="alert alert-danger"><strong>Error!</strong> {error}</div>}
    {deleted && <div className="alert alert-success"><strong>Deleted!</strong> Unit {deleted.unit} has been removed.</div>}
    <Panel className="card border-0" isLoading={isLoading}>
      <PanelBody className="card-body">
        <table className="table table-sm table-responsive table-hover">
          <thead>
            <tr>
              <th>Unit</th>
              <th>Resource(s)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {gradeUnits?.map((gradeUnit) => {
              //const units = project?.gradeUnits?.filter(gu => gu.grade === grade);
              return <tr key={gradeUnit.id}>
                <td>
                  {gradeUnit.unit}
                </td>
                <td>
                  {format.number(gradeUnit.countResources ?? 0)}
                </td>
                <td>
                  {gradeUnit.countResources === 0 && <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => onDeleteUnit(gradeUnit)}>Remove Unit</button>}
                </td>
              </tr>;
            })}
          </tbody>
        </table>
      </PanelBody>
    </Panel>
  </div>);
}